var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInfoCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.999 22c5.523 0 10-4.477 10-10s-4.477-10-10-10c-5.523 0-10 4.477-10 10v0c0.007 5.52 4.48 9.993 9.999 10h0.001zM5.518 6.425c1.576-1.818 3.89-2.962 6.47-2.962 4.721 0 8.548 3.827 8.548 8.548s-3.827 8.548-8.548 8.548c-4.721 0-8.548-3.827-8.548-8.548 0-0.004 0-0.008 0-0.012v0.001c0.002-2.137 0.788-4.089 2.087-5.586l-0.009 0.011z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.997 10.101c0.414 0 0.75 0.336 0.75 0.75v0 5.176c0 0.414-0.336 0.75-0.75 0.75s-0.75-0.336-0.75-0.75v0-5.176c0-0.414 0.336-0.75 0.75-0.75v0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.253 7.973c0-0.414 0.336-0.75 0.75-0.75s0.75 0.336 0.75 0.75c0 0.414-0.336 0.75-0.75 0.75s-0.75-0.336-0.75-0.75z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfoCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info-circle.5fcaad8c.svg";
export { ForwardRef as ReactComponent };